<template>
  <div>
    <dd-rounded-button
        v-if="canUpdateCustomerInsurance"
        @click="editPolicy"
        data-dusk="policy-edit-button"
        type="primary"
        :outline="true"
        icon="mdi mdi-pencil">
      {{ capitalizedPolicyType }} bewerken
    </dd-rounded-button>
    <dd-rounded-button
        v-if="isPackage"
        :href="createPolicy"
        data-dusk="policy-create-button"
        type="success"
        icon="mdi mdi-plus">
        Polis aanmaken
    </dd-rounded-button>
    <dd-rounded-button
        :href="createDamage"
        v-if="canCreateCustomerDamage"
        data-dusk="damage-create-button"
        type="warning"
        icon="mdi mdi-bullhorn">
       Schade aanmaken
    </dd-rounded-button>
    <dd-rounded-button
        icon="mdi mdi-file-move"
        :href="movePolicy"
        v-if="canUpdateCustomerInsurance"
        type="primary"
        data-dusk="move-policy">
      {{ capitalizedPolicyType }} verhuizen
    </dd-rounded-button>
    <dd-rounded-button
        v-if="policy.primary_matrix && !isPackage"
        type="outline"
        data-dusk="policy-claim-button"
        icon="mdi mdi-bullhorn">
      Claimen/Niet claimen
    </dd-rounded-button>
    <dd-confirm-modal
        v-if="canDeleteCustomerInsurance"
        :title="`Je staat op het punt een ${policyType} te verwijderen`"
        :description="`Weet je zeker dat je deze ${policyType} wilt verwijderen? Deze actie is onomkeerbaar.`"
        :okText="`${capitalizedPolicyType} verwijderen`"
        cancelText="Terug"
        @confirm="deletePolicy"
    >
        <dd-rounded-button
            data-dusk="policy-delete-button"
            type="danger"
            icon="mdi mdi-delete"
        >
          {{ capitalizedPolicyType }} verwijderen
        </dd-rounded-button>
    </dd-confirm-modal>
    <dd-rounded-button
        :href="switchPolicy"
        v-if="!isPackage"
        data-dusk="policy-transfer-button"
        type="secondary"
        icon="mdi mdi-rotate-3d">
      Zet polis om naar pakket
    </dd-rounded-button>
    <ExportButton
      v-if="!isPackage && hasPlazaEnabled"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import ExportButton from './ExportButton.vue';
import tenantApi from '~/api/tenant';

export default {
  name: "ActionButtons.vue",
  components: {
    ExportButton
  },
  data(){
    return {
      hasPlazaEnabledValue: false
    };
  },
  mounted(){
    tenantApi.getSetting('aplaza_enabled').then( response => {
      this.hasPlazaEnabledValue = response?.value === 1;
    });
  },
  methods: {
    ...mapActions(`$_policy_show`, {
      deletePolicy: 'deletePolicy',
    }),
    ...mapMutations(`$_policy_show`, {
      setActiveSectionId: 'SET_ACTIVE_SECTION_ID',
    }),
    editPolicy() {
      this.setActiveSectionId(undefined);
      this.navigator.navigatePath(this.editPath);
    },
  },
  computed: {
    ...mapGetters('$_policy_show', {
      policy: 'policy',
      editPath: 'editPath',
      isPackage: 'isPackage',
      policyType: 'policyType',
      capitalizedPolicyType: 'capitalizedPolicyType',
    }),
    ...mapState(`$_policy_show`, {
      customer: 'customer',
      activeStepId: 'activeStepId',
      activeSectionId: 'activeSectionId',
    }),

    canUpdateCustomerInsurance() {
      if (!this.policy?.can) return false;
      return this.policy?.can['update-customer-insurance'];
    },
    canDeleteCustomerInsurance() {
      if (!this.policy?.can) return false;
      return this.policy?.can['delete-customer-insurance'];
    },
    canCreateCustomerDamage() {
      if (!this.policy?.can) return false;
      return this.policy.can['create-customer-damage'];
    },
    hasPlazaEnabled(){
      return this.hasPlazaEnabledValue;
    },
    createDamage() {
      return this.route("damage.create", {
        customer: this.customer.id,
        policy: this.policy.id,

      })
    },
    movePolicy() {
      return this.route('insurance.move', {
        customer: this.customer.id,
        policy: this.policy.id
      })
    },
    createPolicy() {
      return this.route('vue.insurance.policy.create', {
        customer: this.customer.id,
        package: this.policy.id,
      })
    },
    switchPolicy() {
      return this.route('insurance.switch', {
        customer: this.customer.id,
        policy: this.policy.id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
